"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext, useState } from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { ApiIdentitySubscriptionTargetAction } from "@/generated/models/ApiIdentitySubscriptionTargetAction";
import { ApiIdentitySubscriptionActions } from "@/generated/models/ApiIdentitySubscriptionActions";
interface WaveDropMobileMenuFollowProps {
  readonly drop: ApiDrop;
  readonly onFollowChange: () => void;
}
const WaveDropMobileMenuFollow: React.FC<WaveDropMobileMenuFollowProps> = t0 => {
  const $ = _c(23);
  const {
    drop,
    onFollowChange
  } = t0;
  const isFollowing = !!drop.author.subscribed_actions.length;
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    invalidateDrops
  } = useContext(ReactQueryWrapperContext);
  const [mutating, setMutating] = useState(false);
  let t1;
  if ($[0] !== drop.author.id) {
    t1 = async () => {
      await commonApiPost({
        endpoint: `identities/${drop.author.id}/subscriptions`,
        body: {
          actions: Object.values(ApiIdentitySubscriptionTargetAction).filter(_temp)
        }
      });
    };
    $[0] = drop.author.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== invalidateDrops || $[3] !== onFollowChange) {
    t2 = () => {
      invalidateDrops();
      onFollowChange();
    };
    $[2] = invalidateDrops;
    $[3] = onFollowChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setToast) {
    t3 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[5] = setToast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setMutating(false);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t5 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3,
      onSettled: t4
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const followMutation = useMutation(t5);
  let t6;
  if ($[12] !== followMutation || $[13] !== requestAuth) {
    t6 = async () => {
      setMutating(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setMutating(false);
        return;
      }
      await followMutation.mutateAsync();
    };
    $[12] = followMutation;
    $[13] = requestAuth;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const onFollow = t6;
  if (isFollowing) {
    return null;
  }
  const t7 = `tw-border-0 tw-flex tw-items-center tw-gap-x-4 tw-p-4 tw-bg-iron-950 tw-rounded-xl ${mutating ? "tw-opacity-50 tw-cursor-default" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="tw-size-5 tw-flex-shrink-0 tw-text-iron-300"><path strokeLinecap="round" strokeLinejoin="round" d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM3 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 019.374 21c-2.331 0-4.512-.645-6.374-1.766z" /></svg>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== drop.author.handle) {
    t9 = <span className="tw-text-iron-300 tw-font-semibold tw-text-base">Follow {drop.author.handle}</span>;
    $[16] = drop.author.handle;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== mutating || $[19] !== onFollow || $[20] !== t7 || $[21] !== t9) {
    t10 = <button onClick={onFollow} disabled={mutating} className={t7}>{t8}{t9}</button>;
    $[18] = mutating;
    $[19] = onFollow;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default WaveDropMobileMenuFollow;
function _temp(i) {
  return i !== ApiIdentitySubscriptionTargetAction.DropVoted;
}